import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import UnitCreate from '@app/views/ProjectUnit/Create';
import { memo } from 'react';

export default memo(
  withIfUser(UnitCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
